/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import * as farIcons from "@fortawesome/pro-solid-svg-icons";

// named "selected" regular icons in the kit
import {
    faAdd,
    faArrowDown,
    faArrowDownToLine,
    faArrowRight,
    faArrowToBottom,
    faArrowUpRightFromSquare,
    faBars,
    faBasketballHoop,
    faBriefcase,
    // faCheck,
    faCheckCircle,
    faChevronCircleDown,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronCircleUp,
    faChevronDoubleDown,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChevronDoubleUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronsDown,
    faChevronsLeft,
    faChevronSquareDown,
    faChevronSquareLeft,
    faChevronSquareRight,
    faChevronSquareUp,
    faChevronsRight,
    faChevronsUp,
    faChevronUp,
    faCircleCheck,
    faCircleChevronDown,
    faCircleChevronLeft,
    faCircleChevronRight,
    faCircleChevronUp,
    faCircleExclamation,
    faCircleInfo,
    faCircleMinus,
    // faCirclePlus,
    faCircleXmark,
    faClipboardCheck,
    faClose,
    faCloudArrowUp,
    faComment,
    faDiamondExclamation,
    // faDownload,
    faEnvelope,
    faEnvelopeOpenDollar,
    faEye,
    // faFile,
    // faFilePdf,
    faGavel,
    faHand,
    faInfo,
    faLegal,
    faMagnifyingGlass,
    faMessage,
    faMessageCheck,
    faMessageExclamation,
    faMessageMiddle,
    faMessageMiddleTop,
    faMinus,
    faPeopleLine,
    // faPlayCircle,
    // faPlug,
    faPlus,
    faQuoteLeft,
    faQuoteRight,
    faRecycle,
    faSearch,
    // faSortDown,
    // faSortUp,
    // faSpinner,
    faSquareChevronDown,
    faSquareChevronLeft,
    faSquareChevronRight,
    faSquareChevronUp,
    faSquareExclamation,
    faSquareInfo,
    faStar,
    faTimes,
    faTimesCircle,
    faTrash,
    faTrashAlt,
    faTrashCan,
    faTrashCanSlash,
    faTrashSlash,
    faTree,
    faTriangleExclamation,
    faXmark,
} from "@awesome.me/kit-db56931b65/icons/classic/regular";

const regular = {
    ...farIcons,
    faAdd,
    faArrowDown,
    faArrowDownToLine,
    faArrowRight,
    faArrowToBottom,
    faArrowUpRightFromSquare,
    faBars,
    faBasketballHoop,
    faBriefcase,
    // faCheck,
    faCheckCircle,
    faChevronCircleDown,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronCircleUp,
    faChevronDoubleDown,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChevronDoubleUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronsDown,
    faChevronsLeft,
    faChevronSquareDown,
    faChevronSquareLeft,
    faChevronSquareRight,
    faChevronSquareUp,
    faChevronsRight,
    faChevronsUp,
    faChevronUp,
    faCircleCheck,
    faCircleChevronDown,
    faCircleChevronLeft,
    faCircleChevronRight,
    faCircleChevronUp,
    faCircleExclamation,
    faCircleInfo,
    faCircleMinus,
    // faCirclePlus,
    faCircleXmark,
    faClipboardCheck,
    faClose,
    faCloudArrowUp,
    faComment,
    faDiamondExclamation,
    // faDownload,
    faEnvelope,
    faEnvelopeOpenDollar,
    faEye,
    // faFile,
    // faFilePdf,
    faGavel,
    faHand,
    faInfo,
    faLegal,
    faMagnifyingGlass,
    faMessage,
    faMessageCheck,
    faMessageExclamation,
    faMessageMiddle,
    faMessageMiddleTop,
    faMinus,
    faPeopleLine,
    // faPlayCircle,
    // faPlug,
    faPlus,
    faQuoteLeft,
    faQuoteRight,
    faRecycle,
    faSearch,
    // faSortDown,
    // faSortUp,
    // faSpinner,
    faSquareChevronDown,
    faSquareChevronLeft,
    faSquareChevronRight,
    faSquareChevronUp,
    faSquareExclamation,
    faSquareInfo,
    faStar,
    faTimes,
    faTimesCircle,
    faTrash,
    faTrashAlt,
    faTrashCan,
    faTrashCanSlash,
    faTrashSlash,
    faTree,
    faTriangleExclamation,
    faXmark,
};

export { regular };
